import { Client } from "@stomp/stompjs";
import { getAuthSettings, getUnauthSettings } from "../Settings";
import { getLogger } from "../Logger";

const stompLog = getLogger("core.messaging.StompLog");

export class Messaging {
    public static getClient(): Client {
        const result = new Client({connectHeaders: { login: 'msg', passcode: getAuthSettings().amqp }});
        result.brokerURL = getUnauthSettings().messaging_url;
        if (stompLog.isDebugEnabled)
            result.debug = msg => stompLog.debug(msg);
        return result;
    }
}
